import { useApiUrl, useCustom } from "@refinedev/core";
import { useGetGeneralField } from "./ab-testing/use-get-general-field";

export const useGetEventParams = ({ enabled }: { enabled: boolean }) => {
    const apiUrl = useApiUrl("nestjsx");
    const { productCode } = useGetGeneralField({});

    const { data } = useCustom({
        method: "get",
        dataProviderName: "nestjsx",
        url: `${apiUrl}/products/event-params/${productCode}`,
        queryOptions: {
            enabled: Boolean(productCode) && enabled,
        },
        config: {
            headers: {
                "Product-Code": productCode,
            },
        },
    });

    const firebaseEventParams: { param_key: string; param_type: string }[] =
        (data?.data ?? [])?.map((item: any) => item) ?? [];

    const getEventParamType = (paramKey: string) => {
        const paramType = firebaseEventParams.find((item) => item.param_key === paramKey)?.param_type;

        if (paramType && ["integer"].includes(paramType)) {
            return "number";
        }
        return paramType;
    };

    return {
        firebaseEventParams,
        getEventParamType,
    };
};
